import React from "react";
import Home from "../Ui/Home";
import Banner from "../Ui/Banner";
import MostBook from "../Ui/MostBook";
import { useOutletContext, useNavigate } from "react-router-dom";
import WhyChooseUs from "../Ui/WhyChooseUs";
import { FaWhatsapp, FaCalendarCheck, FaStar } from "react-icons/fa";
import ogGirlTechnicianExactLogoImg from "../../Assets/og_girl_technician_exact_logo.jpg";

const Main = () => {
  const { onAddToCart } = useOutletContext();
  const navigate = useNavigate();

  const handleScrollToCategories = () => {
    const el = document.getElementById("categories-section");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <div>
      <Home />
      <Banner />
      <MostBook onAddToCart={onAddToCart} />
      <WhyChooseUs />

      <section className="mx-auto my-16 max-w-7xl px-4 sm:px-6 lg:my-20 lg:px-8">
        <div className="grid overflow-hidden rounded-[1.75rem] border border-[#e8e4dc] bg-[#fbfaf7] shadow-[0_18px_55px_rgba(13,0,76,0.08)] lg:grid-cols-[1.05fr_0.95fr]">
          <div className="relative flex flex-col justify-between p-7 sm:p-10 lg:p-14">
            <div className="absolute left-0 top-10 h-20 w-1 bg-[#AF7D23]" />
            <div>
              <div className="mb-7 flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-[#f9dfdc] px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-[#a73538]">
                  Signature offer
                </span>
                <span className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-[#AF7D23]">
                  <FaStar size={11} /> Loved by homes
                </span>
              </div>

              <p className="mb-3 text-xs font-semibold uppercase tracking-[0.24em] text-gray-400">
                Your home, refreshed
              </p>
              <h2 className="max-w-xl text-3xl font-semibold leading-[1.08] tracking-[-0.03em] text-[#0D004C] sm:text-5xl">
                Make space for what matters.
              </h2>
              <p className="mt-5 max-w-lg text-sm leading-7 text-gray-500 sm:text-base">
                Give every room the care it deserves with trusted professionals, thoughtful service, and a finish you can feel.
              </p>
            </div>

            <div className="my-8 grid max-w-md grid-cols-2 gap-3">
              <div className="rounded-xl border border-[#e8e4dc] bg-white p-4">
                <span className="block text-[10px] font-bold uppercase tracking-[0.12em] text-gray-400">Essential clean</span>
                <span className="mt-2 block text-2xl font-bold text-[#0D004C]">Rs. 799</span>
              </div>
              <div className="rounded-xl border border-[#e3c477] bg-[#fff8e8] p-4">
                <span className="block text-[10px] font-bold uppercase tracking-[0.12em] text-[#AF7D23]">Complete clean</span>
                <span className="mt-2 block text-2xl font-bold text-[#0D004C]">Rs. 1100</span>
              </div>
            </div>

            <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
              <a
                href="https://wa.me/919036011861"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-5 py-3.5 text-xs font-bold text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-[#1ebd59] sm:text-sm"
              >
                <FaWhatsapp size={20} />
                <span>Chat with our team</span>
              </a>

              <button
                onClick={handleScrollToCategories}
                className="flex items-center justify-center gap-2 rounded-xl bg-[#0D004C] px-5 py-3.5 text-xs font-bold text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-[#1a1460] sm:text-sm"
              >
                <FaCalendarCheck size={16} />
                <span>Choose your service →</span>
              </button>
            </div>
          </div>

          <div className="group relative min-h-[22rem] overflow-hidden bg-[#e9e5dc] lg:min-h-full">
            <img
              src={ogGirlTechnicianExactLogoImg}
              alt="Our Genie Verified Professional Technician"
              className="h-full w-full object-cover object-center transition-transform duration-1000 group-hover:scale-105"
            />
            <div className="absolute inset-x-5 bottom-5 rounded-xl border border-white/40 bg-white/80 p-4 backdrop-blur-md sm:inset-x-8 sm:bottom-8">
              <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#AF7D23]">The Our Genie standard</p>
              <p className="mt-1 text-sm font-semibold text-[#0D004C]">Thoughtful service. Beautiful results.</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Main;
